export enum EVideoOnboardingConfig {
    VideoOnboardingInstructions = 1,
    VideoOnboardingInviteFormFields = 2
}